import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, PopoverController, ToastController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import { NewActivityComponentBLL } from './components/events/new-activity/new-activity.bll';
import { AuthState } from './services/auth/auth.model';
import { AuthService } from './services/auth/auth.service';
import { pageView } from './services/menu/menu.pages';
import { MenuService } from './services/menu/menu.service';
import { PlatformService } from './services/platform/platform.service';
import { theme } from './services/theme/theme.model';
import { ThemeService } from './services/theme/theme.service';
import { NotificationsBLL } from './components/notifications/notifications.bll';
import { notificationCount } from './components/notifications/notifications.model';
import { take, skipWhile } from 'rxjs/operators';
import { decodeToken } from 'src/app/util/util';
import { AlertController } from '@ionic/angular';
import { HighlightBLL } from './views/profile/components/highlights/highlight.bll';
import { TeamingUpBLL } from './views/teaming-up/teaming-up.bll';
import { AppBLL } from './app.bll';
// import { QuickWorkoutPage } from './views/quick-workout/quick-workout.page';
import { ImageSliderModelComponent } from './components/image-slider-model/image-slider-model.component';
import { WorkoutDetailBLL } from './components/workout-detail/workout-detail.bll';
import { QuickWorkoutsBLL } from './views/quick-workout/quick-workout.bll';
import { TaxFormBLL } from './services/tax-form/tax-form.bll';
import { defineFullCalendarElement } from '@fullcalendar/web-component';
import { Clipboard } from '@capacitor/clipboard';
import { environment } from 'src/environments/environment';
// import { setTimeout } from 'timers';
// import { ToastService } from './services/toast/toast.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  user: AuthState;
  isMobileDevice: boolean;
  showHyperLink: boolean = false;
  showHyperLinkTraining: boolean = false;

  pages$: Observable<pageView[]>;
  auth$: Observable<AuthState>;
  show_support_bubble: boolean = false;

  //#region Data Observables
  themes$: Observable<theme[]>;
  notificationPayload$: Observable<any>;
  currentTheme$: Observable<string>;
  notificationsCount$: Observable<notificationCount>;
  show_workout_detail$: Observable<boolean>;
  show_add_new_quick_workout$: Observable<boolean>;
  /**
   * Raises the blocking tax-information step. Hosted here because app.component
   * is the only template rendered on every authenticated route — most routes in
   * app-routing.module.ts have no guard at all, so a per-route guard would leave
   * holes.
   */
  tax_profile_required$: Observable<boolean>;

  /** Latest value of tax_profile_required$, read synchronously by canDismissTaxModal. */
  private tax_profile_required = false;

  /**
   * Gates every exit from the blocking step. A hard canDismiss="false" also
   * refuses the dismiss that [isOpen]="false" triggers internally, which left
   * the modal on screen after a successful save; ion-modal only skips the check
   * for role 'handler'. Answering from the gate itself keeps the step
   * undismissable while it is required and lets it close the moment it is not.
   */
  canDismissTaxModal = async (): Promise<boolean> => !this.tax_profile_required;

  // messageCount = 0;

  subscriptionsRes$: Observable<any>;
  openNotifications$: Observable<boolean>;

  //#endregion Data Observables

  notifications_sub: Subscription;

  //filter
  showNotificationMenu: boolean = false;
  openFAQ: boolean = false;
  displayGetPremium = false;
  displayDirectorPro = false;

  fitnessDropdown = false;
  socialDropdown = false;
  selected_tab = '';
  selected_group = '';
  age_less$: Observable<boolean>;
  // panda-connect-chat
  environment = environment;



  userDecodedToken;
  constructor(
    private platform: PlatformService,
    private router: Router,
    private modal: ModalController,
    private menu: MenuService,
    private auth: AuthService,
    private popover: PopoverController,
    private theme: ThemeService,
    private add_menu_bll: NewActivityComponentBLL,
    private highlight_bll: HighlightBLL,
    private notifications_bll: NotificationsBLL,
    private tax_bll: TaxFormBLL,
    private alertController?: AlertController,
    // private calendar?: Calendar,
    private toast?: ToastController,
    // private membershipBll?: MembershipBLL,
    private teamingUpBll?: TeamingUpBLL,
    private appBll?: AppBLL,
    private workoutDetailBLL?: WorkoutDetailBLL,
    private quickWorkoutBll?: QuickWorkoutsBLL,
    private activatedRoute?: ActivatedRoute
    // private chatBLL?: ChatBll
  ) {
    this.isMobileDevice = this.platform.isMobile();
    this.pages$ = this.menu.pages$;
    this.age_less$ = this.menu.age_less$;
    this.auth$ = this.auth.auth$;
    this.currentTheme$ = this.theme.currentTheme$;
    this.themes$ = this.theme.themes$;
    this.notificationPayload$ = this.auth.notificationPayload$;
    this.checkDevicePlatform();
    this.openNotifications$ = this.auth.openNotifications$;
    defineFullCalendarElement();

    // this.calendar.createCalendar('PANDAEvent').then(
    //   (msg) => { console.log(msg);
    //   console.log("calendar createds") },
    //   (err) => { console.log("err,", err); }
    // );
    // // let calOptions = this.calendar.getCalendarOptions();
    // // calOptions.calendarName = 'PANDAEvents';
    // this.calendar.createEventWithOptions('name of event', '', '',  new Date('2023-08-28T09:00:00-07:00'), new Date('2023-08-28T09:00:00-07:00'), {calendarName: 'PANDAEvent'});
  }

  ngOnInit() {
    this.auth.listen();
    // this.activatedRoute?.params.subscribe((params) => {

    //   console.log("params", params)
    // });

    // Not getting token on first reload!
    this.auth$
      .pipe(
        skipWhile((val) => !val.token),
        take(1)
      )
      .subscribe(async (user) => {
        // let age = JSON.parse(localStorage.getItem('age'));
        // if (age && age <= 12) {
        //   this.age_less = true;
        //   console.log("here is under 12 res", age)
        // }

        // this.activatedRoute?.params.pipe(skipWhile(id => !id), take(1)).subscribe((params) => {

        //   console.log("params", params)
        // });


        this.user = user;
        this.userDecodedToken = await decodeToken(user.token);
        this.subscriptionsRes$ = this.appBll.subscriptions$;
        this.appBll.get_subscriptions();
        // this.openAciDetailsModel();

        // this.membershipBll.get_subscriptions();
        this.initObservables();
        this.initDataRetrieval();


        // this.chatBLL.channels$.subscribe((res: any) => {
        //   if (res && res.channels) {

        //     let count = 0;

        //     res.channels.forEach(ch => {
        //       console.log("ch", ch);
        //       count = +ch.counter + count
        //     });

        //     this.messageCount = count;
            

          
        //   }
        // });



      });

    // refresh notification count while listening to FCM.
    this.notifications_sub = this.notificationPayload$.subscribe((res) => {
      this.notifications_bll.get_notification_count();
    });

    this.openNotifications$?.subscribe(res => {
      this.openNotificationMenuAndroid();
    })

    this.show_workout_detail$ = this.workoutDetailBLL.show_workout_detail$;
    this.show_add_new_quick_workout$ = this.quickWorkoutBll.show_add_workout$;
    this.tax_profile_required$ = this.tax_bll.tax_profile_required$;
    // Subscribed here, before the template's async pipe, so the flag is already
    // lowered by the time [isOpen] flips and asks canDismissTaxModal.
    this.tax_profile_required$.subscribe((required) => {
      this.tax_profile_required = required;
    });

    // A long-lived subscription rather than the take(1) one above: this has to
    // run again when a different user signs in on the same app instance, or the
    // second user inherits the first user's answer.
    this.auth$.subscribe((user) => {
      if (user?.isLoggedIn && user?.isEmailVerified) {
        this.tax_bll.checkTaxProfile(user.id, user.role);
      } else {
        this.tax_bll.resetTaxProfileCheck();
      }
    });

    this.menu.initPages(this.user?.role);
  }

  initObservables() {
    this.notificationsCount$ = this.notifications_bll.notificationsCount$;
  }

  toggleFitness(type) {
    // if ((this.displayGetPremium)) {
    //   this.router.navigate(['/challenge']);
    // } else {
      if (type == this.selected_group) {
        this.selected_group = '';
      } else {
        this.selected_group = type;
      }
    // }

  }

  goToGroups(data) {
    console.log(window.location.pathname.split('/')[2] , window.location.pathname)
    if (window.location.pathname.split('/')[2] === 'group') {
      this.router.navigate(['/teaming-up'])
      setTimeout(() => {
        this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
          queryParams: { admin_id: data.admin_id, group: data.group, current_user_role: data?.role, tab: 'forum' },
        });
      }, 0);
    }else{
      this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
        queryParams: { admin_id: data.admin_id, group: data.group, current_user_role: data?.role, tab: 'forum' },
      });
    }
    this.flushPayloadOnClose();
   
  }

  // checkClipboard = async () => {

  //   return `${environment.base_url}+'league-info'`;
 
  // };

  goToGroupsParent(data) {
    if (window.location.pathname.split('/')[2] === 'group') {
      this.router.navigate(['/teaming-up'])
      setTimeout(() => {
        this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
          queryParams: { admin_id: data.admin_id, group: data.group, current_user_role: data?.role, tab: 'parent_forum' },
        });
      }, 0);
    }
    else{
      this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
        queryParams: { admin_id: data.admin_id, group: data.group, current_user_role: data?.role, tab: 'parent_forum' },
      });
    }
    this.flushPayloadOnClose();
   
  }

  goToGroupChat(data) {
    if (window.location.pathname.split('/')[2] === 'group') {
      this.router.navigate(['/teaming-up'])
      setTimeout(() => {
        this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
          queryParams: { admin_id: data.admin_id, group: data.teaming_up_group_name, current_user_role: data?.role, tab: 'group_chat', channel_id: data.teaming_up_channel_id },
        });
      }, 0);
    }else{
      this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
        queryParams: { admin_id: data.admin_id, group: data.teaming_up_group_name, current_user_role: data?.role, tab: 'group_chat', channel_id: data.teaming_up_channel_id },
      });
    }
    this.flushPayloadOnClose();
  }

  goToGroupNotices(data) {
    this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
      queryParams: { admin_id: data.admin_id, group: data.group, current_user_role: data.role, tab: 'notice' },
    });
    this.flushPayloadOnClose();
  }

  goToGroupCalendar(data) {
    this.router.navigate([`teaming-up/group/${data.teamingUP_id}`], {
      queryParams: { admin_id: data.admin_id, group: data.group, current_user_role: data?.role, tab: 'calendar' },
    });
    this.flushPayloadOnClose();
  }

  async warn_subscription() {
    let t = await this.toast.create({
      animated: true,
      color: 'warning',
      message: 'You need to have an active DirectorPro subscription to access this feature.',
      duration: 3000
    });
    t.present();
  }

  async initDataRetrieval() {
    this.auth.auth$.pipe(take(1), skipWhile(val => !val.id)).subscribe(u => {
      this.auth.verify_under_age();
    });
    this.notifications_bll.get_notification_count();
    if (!this.userDecodedToken.dob) this.menu.disableRoutes('all');
    // if (!this.userDecodedToken.age) this.menu.disableRoutes('age_restrictions');
    if (this.userDecodedToken.parent_added) this.menu.disableRoutes('unlock');
    this.subscriptionsRes$.subscribe((subs: any) => {
      if (subs?.subscriptions?.filter(sub => sub?.status === 'active').length === 0) {
        this.menu.disableRoutes('substriction_check');
        this.displayGetPremium = true;
      } 
      if (subs?.subscriptions?.filter(sub => sub?.status === 'active' && sub?.recurly_plan_code == 'directorpro').length > 0) {
        this.menu.disableRoutes('substriction_check');
        this.displayDirectorPro = true;
      } 
    });
  }

  redirectToUserWorkouts(id) {
    this.flushPayloadOnClose();
    this.router.navigate([`/profile/${id}`], {
      queryParams: { workout: true },
    });
  }

  redirectToChallenge(workout_category_id, challenge_id) {
    // this.router.navigate(['/challenge/categories/'+workout_category_id+'/details/'+challenge_id]);
    // this.router.navigate(['/challenge/categories/'+workout_category_id]);
    this.router.navigate(['/challenge']);
    this.flushPayloadOnClose();
  }

  showAddButton(): boolean {
    let show = false;

    if (this.userDecodedToken?.dob === true && this.userDecodedToken?.weight === true && this.userDecodedToken?.gender === true) {
      if (this.userDecodedToken?.age === true)
        show = true;
      else {
        if (this.userDecodedToken?.parent_added === true)
          show = true;
      }
    }

    return show;
  }

  async ionViewDidEnter() {
    this.initDataRetrieval();
    // this.openAciDetailsModel();
  }

  ngOnDestroy() {
    this.notifications_sub.unsubscribe();
  }

  whiteListed = ['auth/reset-password', 'auth/register?parent_email', 'auth/register?ref', 'policies', 'game-contract', 'referee-contract', 'assigned-referee-contract', 'bus-service-contract', 'event-staff-contract', 'public-profile', 'public-profile?id'];
  whiteListedFlag = this.whiteListed.some((i) =>
    window.location.href.includes(i)
  );

  async checkDevicePlatform() {
    // Only perform the default redirect to the auth entry points when
    // the app is at the root (no deep-link path). If the user has loaded a
    // deep-link (e.g. /teaming-up/group/...), we must not override it.
    try {
      const pathname = window.location.pathname || '/';
      const isRootPath = pathname === '/' || pathname === '' || pathname.endsWith('/index.html');
      if (!this.whiteListedFlag && isRootPath) {

        if (this.isMobileDevice) {
          this.router.navigate(['auth/welcome']);
        } else {
          this.router.navigate(['auth/login']);
        }

        // If user is at root, decide redirect based on auth state
        this.auth.auth$.pipe(skipWhile(val => !val.token), take(1)).subscribe((state) => {
          console.log("auth state in app comp", state);

          const loggedIn = !!state && !!state.token;
          if (loggedIn) {
            // go to home for authorized users
            this.router.navigate(['home']);
          }
        }, (err) => {
          // On error reading auth state, default to login
          this.router.navigate(['auth/login']);
        });
      }
      // If not rootPath, assume it's a deep-link and let the router/guards handle it.
    } catch (e) {
      // Fallback: if anything goes wrong reading location, avoid forcing a redirect
      // to prevent losing deep-link URLs.
      console.warn('checkDevicePlatform: error checking pathname, skipping forced redirect', e);
    }
  }

  navigateToPage(url: string, tab: string) {
    this.selected_tab = tab;
   
    // if((this.displayGetPremium && tab == 'comparison') || (this.displayGetPremium && tab == 'email-coach') ) {
    if((this.displayGetPremium && tab == 'email-coach') ) {
      this.router.navigate(['/challenge']);
    } else {
      this.menu.changePage(url);
    }

  }

  async navigateToProPages(url, tab) {

    if (tab == 'search-events') {
      this.selected_tab = tab;
      this.router.navigate([url]);
      return;
    }

    if (this.displayGetPremium) {
      let t = await this.toast.create({
        animated: true,
        color: 'warning',
        message: 'You need to have an active Panda+ premium subscription to access this feature.',
        duration: 3000
      });
      t.present();
    } else {
      this.selected_tab = tab;
      this.router.navigate([url]);
    }
  }

   navigateToDirectorProPage(url: string, tab: string) {
    this.selected_tab = tab;
    if(this.displayDirectorPro) {
        this.menu.changePage(url);
        this.auth.get_ad_admin();
    } else {
      let ad_admin_id = localStorage.getItem('ad_admin_id');
      let ad_admin_email = localStorage.getItem('ad_admin_email');
      let using_sub_admin = localStorage.getItem('using_sub_admin');

      if(using_sub_admin != '1') {
        this.auth.get_ad_admin();
      }
      
      if(ad_admin_id && ad_admin_email) {
        localStorage.setItem('using_sub_admin', '1');
        localStorage.setItem('selected_account', '2');
        this.auth.get_ad_admin();
        this.menu.changePage(url);
      } else {
        this.warn_subscription();
      }
        // this.router.navigate(['/challenge']);
    }
  }

  // Assigner Referee Hub pages are free for assigners: skip the Director Pro
  // subscription check. Assigners linked to an AD account (or with Director Pro)
  // keep the existing sub-admin flow; everyone else opens on their own account.
  navigateToAssignerPage(url: string, tab: string) {
    const hasAdAdmin = localStorage.getItem('ad_admin_id') && localStorage.getItem('ad_admin_email');
    if (this.user?.role !== 'assigner' || this.displayDirectorPro || hasAdAdmin) {
      this.navigateToDirectorProPage(url, tab);
      return;
    }
    this.selected_tab = tab;
    this.auth.get_ad_admin();
    this.menu.changePage(url);
  }

  openHyperLink(link: string, id: string) {
    if (this.isMobileDevice) {
      this.HyperLinkDialog(link, id);
    } else {
      window.open(link, '_blank');
    }
  }

  openAccountSettings() {
    this.popover.dismiss();
    this.router.navigate(['settings']);
  }

  account_setting_verifier() {
    // this.popover.dismiss();
    this.selected_tab = 'verifier';

    this.router.navigate(['settings'],
    {
      queryParams: {verifier: 'true' },
    });
    }

  
  
  openSubscriptions() {
    this.popover.dismiss();
    this.router.navigate(['settings'],
    {
      queryParams: {membership: 'true' },
    });
  }

  async setTheme(color: string) {
    this.theme.setTheme(color);
  }

  async logOut() {
    await this.auth.logout();
    this.popover.dismiss();
    this.menu.hideMenu();
    this.router.navigate(['auth/login']);
    // window.location.href = window.location.href;

    setTimeout(() => {
          window.location.reload();
    }, 0);

  }

  flushPayloadOnClose() {
    this.auth.notificationPayload$.next(null);
  }

  notificationsPopoverDismiss() {
    this.notifications_bll.get_notification_count();
  }

  show_addMenu() {
    this.menu.collapseMenu();
    this.add_menu_bll.toggle_add_menu(true);
  }

  async show_quick_workout() {
    this.selected_tab = 'show_quick_workout';
    this.menu.collapseMenu();
    this.quickWorkoutBll.toggle_add_menu(true);
    // let m = await this.modal.create({
    //   component: QuickWorkoutPage,
    //   animated: true,
    //   backdropDismiss: false,
    //   cssClass: 'fullscreen_modal'
    // });
    // await m.present();
  }

  collapseMenu() {
    this.menu.collapseMenu();
  }

  openAddHighlightModel() {
    this.menu.collapseMenu();
    this.highlight_bll.openAddHighlightModel();
  }
  
  redirectToHighlight() {
    this.menu.collapseMenu();
    this.router.navigate(['/profile/0'], {
      queryParams: { videos: true },
    });
  }

  openAddTeamingUpGroup() {
    this.menu.collapseMenu();
    this.teamingUpBll.openAddGroupModel(this.user?.role);
  }

  // calls when auth initilized etc login with username and password
  // async openAciDetailsModel() {
  //   // this.activatedRoute?.params.pipe(skipWhile(id => !id), take(1)).subscribe((params) => {
  //   //   console.log("params1221", params);
  //   //   if(!params.stopQuickMenue) {
  //   //     this.auth.get_user_aci(this.user?.role);
  //   //   }
  //   // });
  //   console.log("params1221 out");

  //   this.activatedRoute?.queryParams.pipe(skipWhile(p => !p), take(1))
  //   .subscribe((params) => {
  //     if(!params.stopQuickMenue) {
  //             console.log("params1221 in", params);

  //       this.auth.get_user_aci(this.user?.role);
  //     }
  //   });
  // }

  openNotificationMenu() {
    if (this.showNotificationMenu) {
      this.auth.closeNotifications();
    }
    this.menu.collapseMenu();
    this.showNotificationMenu = !this.showNotificationMenu;
    this.notificationsPopoverDismiss();
    this.flushPayloadOnClose();
  }

  openNotificationMenuAndroid() {
    this.menu.collapseMenu();
    this.showNotificationMenu = true;
    this.notificationsPopoverDismiss();
    this.flushPayloadOnClose();
  }

  goToProfile(id) {
    this.menu.collapseMenu();
    this.router.navigate(['/profile/' + id], {
      queryParams: {
        replaceUrl: true,
        skipLocationChange: false
      }
    });
  }

  goToHome() {
    this.selected_tab = 'home';
    this.menu.collapseMenu();
    this.router.navigate(['/home'], {
      queryParams: {
        stopQuickMenue: true,
        replaceUrl: true,
        skipLocationChange: false
      }
    });
  }

  goToDailyActivity() {
    this.selected_tab = 'home';
    this.menu.collapseMenu();
    this.router.navigate(['/panda/activities'], {
      queryParams: {
        stopQuickMenue: true,
        replaceUrl: true,
        skipLocationChange: false
      }
    });
  }

  showHyperLinkFunc(flag, id) {
    if (id === 'training') {
      this.showHyperLinkTraining = flag;
    } else if (id === 'nutrition') {
      this.showHyperLink = flag;
    }
  }

  refresh() {
    window.location.reload();
  }

  closeSlideOver(event) {
    if (event == false) {
      this.showNotificationMenu = false;
    } else if (event == null) {
      this.showNotificationMenu = false;
    } else {
      this.showNotificationMenu = true;
    }
  }

  public async HyperLinkDialog(link, id) {

    if (id === 'training') {
      
      const alert = await this.alertController.create({
        subHeader: `Use the ‘Panda15’ coupon code at checkout to receive a 15% discount on items in your cart.`,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => { },
          },
          {
            text: 'Go',
            role: 'go',
            handler: () => {
              window.open(link, '_blank');
            },
          },
        ],
      });

      await alert.present();

    } else if (id === 'nutrition') {

      const alert = await this.alertController.create({
        subHeader: `Use 'Panda20' as your discount code to receive 20% at checkout.  If you subscribe to any order, you will receive 35% at checkout`,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => { },
          },
          {
            text: 'Go',
            role: 'go',
            handler: () => {
              window.open(link, '_blank');
            },
          },
        ],
      });

      await alert.present();

    } else {
      window.open(link, '_blank');
    }

  }

  async openQuickStartModel() {
    // check that the logged in user is athlete and navigate from Login Page
      const m = await this.modal.create({
        component: ImageSliderModelComponent,
        animated: true,
        backdropDismiss: true,
        cssClass: 'sliderModel'
      });
      m.onDidDismiss().then(data => {
      });
      await m.present();
  }

  open_youtube_channel() {
    window.open('https://www.youtube.com/@pandastronger7618/featured', '_blank');
  }

  open_web_donations() {
    window.open('https://www.pandastronger.com/donations', '_blank');
  }

  open_youtube_videos(type) {
    if (type === 'quick-start') {
      window.open('https://www.youtube.com/watch?v=ZJt4mwjzj2o&list=PLKEGN3VAbZgfPsvNZNGfi3_Kn1Fc_X0mY&index=1&t=32s', '_blank');
    } else if (type === 'overview') {
      window.open('https://www.youtube.com/watch?v=ZJW6C27mdMk&list=PLKEGN3VAbZgfPsvNZNGfi3_Kn1Fc_X0mY&index=2&t=26s', '_blank');
    } else if (type === 'features') {
      window.open('https://www.youtube.com/watch?v=sxaqwO2YI2o', '_blank');
    } else if (type === 'groups') {
      window.open('https://www.youtube.com/watch?v=H2ZJDVNBmp8', '_blank');
    } else if (type === 'aci') {
      window.open('https://youtu.be/Dcn-vXI4HAg', '_blank');
    } else if (type === 'entry') {
      window.open('https://youtu.be/ZH-6aDucHqQ', '_blank');
    }  else if (type === 'aci-compute') {
      window.open('https://pandastrongerblobstorage.blob.core.windows.net/documents/documents/teaming_up_doc_b10678c2-bd3b-4e5e-b3bc-ec43e65ee35e', '_blank');
    } 
  }

  openDocuments(type) {
    if (type === 'athlete') {
      window.open('https://netorgft6776948-my.sharepoint.com/:b:/g/personal/glen_parrillo_parcsports_com/EWcQnjW58PVFn5sB5wamDVIBFWn5-WDGB_ZbKutj2ocyYQ?e=lp0MVY&isSPOFile=1', '_blank');
    } else if (type === 'coach') {
      window.open('https://netorgft6776948-my.sharepoint.com/:b:/g/personal/glen_parrillo_parcsports_com/EeUcdRf_EUJMsoUAnplvI-oBEf6YPIXxAJEUSHmstQseFw?e=c8KHDn', '_blank');
    } else if (type === 'parent') {
      window.open('https://netorgft6776948-my.sharepoint.com/:b:/g/personal/glen_parrillo_parcsports_com/EYCfLvxRIDtBpS4KNfkvmSkBl6ORNP-zd50BcXhmEBy6Hg?e=TjFmng', '_blank');
    }
  }

  public async FAQDialog() {
    this.openFAQ = true;
  }


}
